var _rect, _path, _path2, _g, _path3, _g2, _path4, _g3, _path5, _g4, _path6, _g5, _path7, _g6, _path8, _g7, _path9, _g8, _path0, _g9, _path1, _g0, _path10, _g1, _path11, _g10, _path12, _g11, _path13, _g12, _path14, _g13, _path15, _g14, _path16, _g15, _path17, _g16, _path18, _g17, _path19, _g18, _path20, _g19, _path21, _g20, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFormBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1126,
    height: 506,
    viewBox: "0 0 1126 506",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1623_36489)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1126,
    height: 506,
    rx: 8,
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.05,
    clipPath: "url(#clip1_1623_36489)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1133 -145H-6V614H1133V-145Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1623_36489",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -6,
    y: -145,
    width: 1139,
    height: 759
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1133 -145H-6V614H1133V-145Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1623_36489)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M796.58 805.608C693.419 837.659 583.437 836.695 476.881 818.431C405.23 806.148 328.509 792.997 267.528 752.675C222.488 722.894 181.575 686.574 148.392 643.988C75.2908 550.17 42.4997 426.006 59.7487 308.348C71.2116 230.157 104.672 155.556 154.252 94.1108C211.157 23.5876 292.31 -29.6745 380.276 -52.0604C483.185 -78.2475 565.014 -48.8696 654.563 1.04831C679.544 14.9744 705.633 28.0156 733.531 34.9468C772.017 44.5071 813.545 44.2764 852.85 53.7396C889.68 62.6078 928.286 72.1104 960.283 93.2577C997.141 117.617 1022.65 160.273 1037.38 200.942C1054.54 248.332 1059.62 299.187 1062.04 349.528C1066.09 433.633 1062.75 519.781 1033.63 598.796C1017.12 643.61 997.544 689.235 961.006 721.298C927.469 750.729 886.215 770.248 845.508 787.632C829.403 794.511 813.079 800.482 796.58 805.608Z",
    fill: "#FFEACF"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_1623_36489",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -6,
    y: -145,
    width: 1139,
    height: 759
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1133 -145H-6V614H1133V-145Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_1623_36489)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M759.749 16.1935C792.344 16.1935 818.767 -10.2183 818.767 -42.799C818.767 -75.3797 792.344 -101.792 759.749 -101.792C727.154 -101.792 700.73 -75.3797 700.73 -42.799C700.73 -10.2183 727.154 16.1935 759.749 16.1935Z",
    fill: "#FFEAA4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M811.322 -33.9689C816.185 -62.4402 797.037 -89.4616 768.553 -94.3228C740.07 -99.184 713.036 -80.0443 708.173 -51.573C703.31 -23.1018 722.458 3.91956 750.942 8.78079C779.425 13.642 806.459 -5.49769 811.322 -33.9689Z",
    stroke: "#D3AB72",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M759.746 -1.09814V6.05165",
    stroke: "#D3AB72",
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_1623_36489",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -6,
    y: -145,
    width: 1139,
    height: 759
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1133 -145H-6V614H1133V-145Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_1623_36489)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.0067 -1.77225C40.4097 2.23527 58.7597 -4.80065 69.0958 -10.7907C91.2273 -23.6163 108.414 -46.5199 115.272 -71.0902C120.462 -89.6796 118.767 -118.421 94.866 -122.617C85.4609 -124.269 75.0064 -118.944 66.9575 -114.425C38.1135 -98.226 22.983 -66.8808 16.6699 -35.4977C15.3426 -28.9004 14.4678 -22.0284 16.0275 -15.4813C17.8575 -7.79264 22.3026 -3.6151 28.0067 -1.77225Z",
    fill: "#98A48D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-20.7686 249.548C-41.708 160.865 -17.3896 68.1924 29.9837 -7.86244C53.3408 -45.3616 79.8006 -82.3978 109.553 -114.642",
    stroke: "#2B301F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_1623_36489",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -6,
    y: -145,
    width: 1139,
    height: 759
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1133 -145H-6V614H1133V-145Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_1623_36489)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.6742 319.173C21.8079 324.988 28.0724 329.6 40.6045 331.849C49.6208 333.468 59.0806 332.687 68.4082 331.875C93.5953 329.683 116.851 322.675 139.022 309.368C149.737 302.938 160.427 295.398 166.715 284.79C175.618 269.768 172.212 247.804 157.943 238.793C142.294 228.909 116.779 232.832 99.2432 238.928C72.0378 248.387 6.34638 282.841 19.6742 319.173Z",
    fill: "#98A48D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-30.8594 383.162C-18.0919 358.238 -2.1824 334.266 18.9863 315.663C60.985 278.753 118.057 270.086 170.206 256.022",
    stroke: "#2B301F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_1623_36489",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -6,
    y: -145,
    width: 1139,
    height: 759
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M1133 -145H-6V614H1133V-145Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_1623_36489)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.7022 203.193C36.9936 226.902 77.2596 210.403 96.9187 202.508C128.562 189.802 158.356 173.079 175.37 142.108C179.92 133.826 183.381 124.662 183.27 115.215C183.158 105.767 178.968 96.0097 170.97 90.973C164.197 86.7074 155.7 86.2779 147.724 86.9792C124.839 88.9936 103.282 99.2492 84.7861 112.872C67.1574 125.854 49.8993 140.218 35.6906 156.945C27.625 166.44 18.5616 179.43 18.7651 192.439C18.8304 196.747 19.8555 200.33 21.7022 203.193Z",
    fill: "#98A48D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.788 103.584C154.723 116.466 129.325 130.42 104.304 145.09C78.3981 160.277 49.7136 174.1 28.1667 195.392C5.96988 217.327 -8.49694 247.087 -11.4766 278.188",
    stroke: "#2B301F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask5_1623_36489",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -6,
    y: -145,
    width: 1139,
    height: 759
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M1133 -145H-6V614H1133V-145Z",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_1623_36489)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M133.08 249.217C142.045 243.128 150.92 235.148 154.057 224.683C160.691 202.551 143.922 183.167 125.549 178.216C110.78 174.235 96.4239 179.268 82.3671 187.084C67.1971 195.518 52.8396 205.887 39.7609 217.858C34.2481 222.904 28.872 228.349 25.1984 234.92C15.5457 252.188 23.4656 265.786 39.4951 269.268C70.078 275.914 104.676 268.505 133.08 249.217Z",
    fill: "#6D8257"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.205 196.521C131.319 199.336 112.168 206.062 94.0194 214.511C76.2845 222.767 57.6838 232.123 42.8707 245.076C24.0864 261.502 -31.2797 309.046 -30.6509 445.476",
    stroke: "#2B301F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask6_1623_36489",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -6,
    y: -145,
    width: 1139,
    height: 759
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M1133 -145H-6V614H1133V-145Z",
    fill: "white"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_1623_36489)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-34.8544 99.0989C-41.0156 111.937 -45.769 126.162 -43.6398 140.24C-41.5107 154.319 -30.719 167.883 -16.5286 169.126C-4.14389 170.21 7.01376 162.234 16.7818 154.548C45.1596 132.22 73.3689 108.211 91.2147 76.8284C96.5604 67.4274 100.975 57.1915 101.584 46.394C102.193 35.5964 98.4678 24.1234 89.974 17.4245C78.5308 8.39843 61.912 10.1047 48.2061 15.064C12.0527 28.14 -18.6077 65.2399 -34.8544 99.0989Z",
    fill: "#6D8257"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-57.4141 255.286C-56.9812 225.296 -52.5255 195.615 -40.2243 168.134C-27.592 139.916 -8.56462 115.02 11.4894 91.612C35.2687 63.8569 61.4975 37.0824 94.363 20.603",
    stroke: "#2B301F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask7_1623_36489",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -6,
    y: -145,
    width: 1139,
    height: 759
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M1133 -145H-6V614H1133V-145Z",
    fill: "white"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask7_1623_36489)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M922.376 -60.3501C902.9 -65.8544 882.624 -66.3174 872.145 -52.4839C861.221 -38.0629 866.774 -17.9873 885.01 -5.438C909.434 11.3723 936.963 14.1017 967.223 19.7335C990.622 24.0871 1003.17 14.8349 998.727 0.468536C992.591 -19.3793 973.525 -36.8242 951.518 -48.5067C943.141 -52.9529 932.875 -57.384 922.376 -60.3501Z",
    fill: "#6D8257"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M869.223 -47.3135C964.419 -26.1799 1109.64 57.8172 1162.7 277.508",
    stroke: "#2B301F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask8_1623_36489",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -6,
    y: -145,
    width: 1139,
    height: 759
  }, _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M1133 -145H-6V614H1133V-145Z",
    fill: "white"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask8_1623_36489)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1017.56 53.527C1006 44.5859 993.297 36.2855 978.631 32.1672C963.965 28.0488 946.958 28.6894 934.854 36.5329C926.122 42.192 920.747 50.9585 917.303 59.98C901.594 101.185 969.12 128.944 1005.96 133.822C1028.14 136.759 1054.86 134.122 1055.74 109.921C1056.49 88.9374 1034.7 66.7836 1017.56 53.527Z",
    fill: "#6D8257"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M918.406 55.0251C926.036 55.8995 933.385 58.0611 940.67 60.2562C974.615 70.4845 1008.99 82.0774 1036.13 103.603C1093.33 148.957 1138.76 201.458 1145.95 274.854",
    stroke: "#2B301F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask9_1623_36489",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -6,
    y: -145,
    width: 1139,
    height: 759
  }, _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M1133 -145H-6V614H1133V-145Z",
    fill: "white"
  }))), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask9_1623_36489)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1064.83 170.442C1049.26 158.542 1029.62 147.974 1010.76 150.533C992.614 152.997 980.438 167.288 975.74 182.748C967.347 210.381 981.302 235.678 1008.04 254.598C1031.47 271.172 1075.14 297.494 1104.07 292.081C1125.34 288.101 1130.28 262.266 1122.32 242.825C1109.96 212.632 1092.81 191.829 1064.83 170.442Z",
    fill: "#98A48D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M982.023 169.329C1026.3 192.196 1068.93 220.422 1101.6 258.509C1146.15 310.45 1169.67 378.759 1171.76 446.753",
    stroke: "#2B301F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask10_1623_36489",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -6,
    y: -145,
    width: 1139,
    height: 759
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M1133 -145H-6V614H1133V-145Z",
    fill: "white"
  }))), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask10_1623_36489)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1015.81 228.68C1006.36 223.255 996.402 218.251 985.616 216.736C974.831 215.221 962.985 217.696 955.364 225.472C947.891 233.099 945.587 244.648 946.878 255.245C949.018 272.825 960.013 288.463 974.008 299.325C988.002 310.184 1004.83 316.777 1021.78 321.913C1041.91 328.009 1082.22 327.801 1077.27 296.516C1072.49 266.273 1040.26 242.723 1015.81 228.68Z",
    fill: "#6D8257"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M948.109 237.679C961.802 243.339 975.385 249.263 988.851 255.442C1002.47 261.69 1015.98 268.213 1028.86 275.858C1075.55 303.561 1113.55 346.823 1131.37 398.081",
    stroke: "#2B301F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask11_1623_36489",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -6,
    y: -145,
    width: 1139,
    height: 759
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M1133 -145H-6V614H1133V-145Z",
    fill: "white"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask11_1623_36489)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1088.63 347.931C1079.26 343.336 1061.55 339.467 1052.99 345.671C987.849 392.911 1127.69 463.131 1139.95 430.383C1152.96 395.643 1110.79 358.804 1088.63 347.931Z",
    fill: "#98A48D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1041.32 356.564C1071.35 371.653 1099.99 390.194 1123.29 414.4C1146.59 438.606 1164.38 468.812 1170.42 501.856",
    stroke: "#2B301F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask12_1623_36489",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -6,
    y: -145,
    width: 1139,
    height: 759
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M1133 -145H-6V614H1133V-145Z",
    fill: "white"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask12_1623_36489)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-21.0191 387.7C2.65537 404.222 30.4136 415.6 59.2424 417.19C66.1615 417.571 73.3037 417.354 79.7004 414.69C86.097 412.026 91.6538 406.486 92.6835 399.636C93.7177 392.762 90.1594 386.028 85.9345 380.509C80.1362 372.933 72.915 366.563 65.4188 360.661C44.5205 344.207 22.1414 334.313 -4.93797 333.729C-14.0135 333.533 -23.9304 332.393 -32.517 335.81C-35.7578 337.1 -38.9348 338.79 -41.2478 341.401C-55.792 357.815 -33.6484 378.886 -21.0191 387.7Z",
    fill: "#6D8257"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.3807 408.05C76.3863 397.705 62.8322 389.35 49.3434 381.045C35.6071 372.586 21.813 364.096 7.0212 357.658C-13.8696 348.565 -36.7787 343.691 -59.5207 345.083C-82.2627 346.475 -104.798 354.322 -122.547 368.602",
    stroke: "#2B301F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask13_1623_36489",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -6,
    y: -145,
    width: 1139,
    height: 759
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M1133 -145H-6V614H1133V-145Z",
    fill: "white"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask13_1623_36489)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M148.75 18.9318C144.351 23.4661 136.89 33.664 136.748 40.3128C136.657 44.5572 139.291 48.5024 142.721 51.0102C161.015 64.3853 201.829 56.0621 220.532 47.323C236.771 39.736 255.987 31.047 255.279 9.91338C254.239 -21.1525 196.619 -10.4688 180.571 -3.28867C168.586 2.0729 157.92 9.48378 148.75 18.9318Z",
    fill: "#98A48D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-66.6484 210.806C-35.3168 167.313 5.97117 132.005 48.6153 99.5165C106.464 55.4429 183.146 18.0044 255.127 7.54541",
    stroke: "#2B301F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask14_1623_36489",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -6,
    y: -145,
    width: 1139,
    height: 759
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M1133 -145H-6V614H1133V-145Z",
    fill: "white"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask14_1623_36489)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1097.93 -47.5445C1092.89 -48.4446 1087.53 -48.6981 1082.8 -46.7308C1075.88 -43.8542 1071.65 -36.841 1068.85 -29.8977C1057.35 -1.38662 1062.61 31.551 1075.15 59.6233C1087.69 87.6942 1106.9 112.143 1124.43 137.404C1133.91 151.072 1144.42 166.131 1160.58 170.117C1164.24 171.022 1168.14 171.283 1171.77 170.24C1182.55 167.139 1186.95 154.409 1188.66 143.332C1194.74 103.832 1186.66 63.3409 1169.76 27.4281C1155.28 -3.35851 1134.52 -41.0186 1097.93 -47.5445Z",
    fill: "#98A48D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1079.34 -43.9331C1092.93 -24.5179 1106.54 -5.05864 1118.02 15.6681C1130.6 38.3729 1140.54 62.4453 1149.46 86.8183C1176.06 159.508 1193.83 235.423 1202.25 312.366",
    stroke: "#2B301F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask15_1623_36489",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -6,
    y: -145,
    width: 1139,
    height: 759
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M1133 -145H-6V614H1133V-145Z",
    fill: "white"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask15_1623_36489)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M739.507 270.442L726.893 287.624L686.27 245.592L658.84 278.83C658.84 278.83 686.575 326.239 701.525 342.51C717.401 359.79 742.623 374.479 761.798 348.112C775.088 329.838 794.353 301.714 794.353 301.714",
    fill: "#ED8E6E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M822.689 193.696C822.689 193.696 794.091 196.107 775.741 215.489C765.045 226.786 731.832 279.661 731.832 279.661L785.423 319.437L820.243 263.418",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M742.004 263.898L796.857 301.766",
    stroke: "#231F20",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M789.12 251.898C788.274 268.679 787.494 285.956 793.025 301.822C797.863 315.701 820.75 332.546 820.75 332.546C820.75 332.546 830.08 369.584 826.94 393.495L990.769 402.377C990.769 402.377 978.048 359.794 961.688 329.199C950.138 307.601 954.04 260.519 939.278 227.505C935.286 218.576 880.817 177.557 880.817 177.557L825.766 193.713L789.12 251.898Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M789.117 251.898C788.271 268.679 788.52 289.966 794.352 304.89",
    stroke: "#231F20",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M836.289 209.55L868.099 396.905",
    stroke: "#231F20",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M844.848 207.973L876.656 395.328",
    stroke: "#231F20",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M726.086 287.563C732.158 292.553 738.261 297.571 743.426 303.492C748.591 309.413 752.824 316.335 754.54 324.003",
    stroke: "#231F20",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M698.878 239.473C699.535 228.534 700.079 213.964 695.26 209.127C688.381 202.218 676.521 199.768 667.083 195.721C666.105 195.302 664.902 195.405 663.948 195.876C663.194 196.248 662.661 196.96 662.281 197.71C660.776 200.674 661.464 204.595 663.892 206.871C664.933 207.845 666.246 208.582 667.7 209.195C667.056 209.649 666.466 210.173 665.979 210.792C665.718 211.123 665.497 211.481 665.303 211.854C663.564 211.665 661.787 212.097 660.181 212.817C658.843 213.416 657.558 214.215 656.651 215.367C655.9 216.323 655.485 217.497 655.251 218.737C655.166 218.736 655.082 218.711 654.999 218.713C653.19 218.772 651.488 219.622 650.042 220.709C648.952 221.529 647.948 222.517 647.362 223.749C646.198 226.195 646.99 229.363 647.615 231.877C648.177 234.133 648.903 236.346 649.782 238.497C650.844 241.093 652.808 242.406 655.111 242.09C655.251 244.584 655.333 247.08 655.301 249.571C655.24 254.524 653.18 259.297 653.227 264.418C653.281 270.244 655.202 276.005 658.363 280.816C661.983 286.327 673.803 300.726 673.803 300.726L703.288 269.8C700.562 259.926 697.786 257.639 698.878 239.473Z",
    fill: "#ED8E6E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M667.707 208.65C667.707 208.65 676.003 211.126 679.44 213.676C682.292 215.792 683.61 219.346 684.783 222.697",
    stroke: "#231F20",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M696.09 223.98C692.409 221.907 689.568 217.261 685.324 216.128C682.307 215.328 675.675 216.049 671.64 215.484C669.017 215.117 667.664 220.29 668.261 222.502C668.936 225.003 670.918 226.137 673.389 227.074C675.805 227.989 678.96 227.54 680.588 229.509C681.954 231.163 677.701 242.132 677.207 244.201C674.902 253.848 676.133 258.187 679.163 267.645",
    fill: "#ED8E6E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M696.09 223.98C692.409 221.907 689.568 217.261 685.324 216.128C682.307 215.328 675.675 216.049 671.64 215.484C669.017 215.117 667.664 220.29 668.261 222.502C668.936 225.003 670.918 226.137 673.389 227.074C675.805 227.989 678.96 227.54 680.588 229.509C681.954 231.163 677.701 242.132 677.207 244.201C674.902 253.848 676.133 258.187 679.163 267.645",
    stroke: "#231F20",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M673.115 215.707C672.758 216.8 672.451 217.91 672.196 219.03C672.011 219.842 671.877 220.776 672.392 221.439C672.851 222.03 673.669 222.204 674.417 222.336C675.044 222.447 675.708 222.556 676.301 222.33C676.963 222.08 677.408 221.451 677.626 220.791C677.841 220.13 677.867 219.428 677.931 218.738C678.02 217.79 678.188 216.847 678.431 215.924",
    stroke: "#231F20",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M665.214 212.046C664.606 216.424 664.703 220.9 665.499 225.248C665.906 227.475 666.538 229.749 668.005 231.472C669.473 233.194 671.973 234.215 674.073 233.369C676.134 232.54 677.234 230.161 677.2 227.942",
    stroke: "#231F20",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M655.246 218.903C655.331 221.978 655.419 225.07 655.987 228.094C656.555 231.118 657.63 234.098 659.514 236.533C660.455 237.749 660.511 237.758 662.027 238.022C663.543 238.286 665.149 237.814 666.352 236.851C667.634 235.825 668.44 234.318 669.014 232.779",
    stroke: "#231F20",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M655.254 242.192C656.394 242.175 657.521 241.713 658.347 240.927C659.483 239.845 660.044 239.251 660.527 237.759",
    stroke: "#231F20",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M886.683 98.7621C878.81 93.692 869.482 90.0792 860.492 90.9384L858.852 97.9348C869.739 101.806 878.886 110.112 884.632 119.803C890.379 129.494 892.917 140.477 893.234 151.18L917.56 145.164C914.913 126.985 903.221 109.412 886.683 98.7621Z",
    fill: "#FFBF66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M886.363 120.448C883.704 111.008 876.741 100.729 866.606 98.5677C864.637 98.1472 861.5 98.7438 859.758 97.9863C864.613 100.102 867.347 105.297 868.905 110.353C873.4 124.928 869.801 133.333 866.265 144.987L886.025 147.153C888.28 138.435 888.807 129.122 886.363 120.448Z",
    fill: "#FFBF66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M850.84 95.8793C850.922 93.0725 852.356 89.9986 855.066 89.2441C857.555 88.5504 860.172 90.0669 861.858 92.0221C863.32 93.7177 864.365 95.8444 864.441 98.0804C864.517 100.316 863.515 102.642 861.628 103.85C859.742 105.059 856.989 104.905 855.461 103.269C854.886 100.031 853.648 97.5962 850.84 95.8793Z",
    fill: "#FFBF66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M826.028 174.434C826.107 179.386 825.642 184.368 823.904 188.986C820.883 197.003 814.254 203.327 811.611 211.475C810.182 215.882 809.994 220.62 808.533 225.016C807.072 229.412 803.781 233.721 799.18 234.276C797.467 234.482 795.716 234.139 794.126 233.469C788.648 231.161 785.458 225.277 784.292 219.449C783.126 213.622 783.56 207.604 783.047 201.683C782.641 197.007 781.642 192.385 780.079 187.96C778.362 183.096 775.95 178.404 775.261 173.293C774.507 167.699 775.883 162.158 776.281 156.599C776.612 151.976 775.976 147.539 776.336 142.863C777.088 133.095 778.31 123.135 781.551 113.84C781.551 113.84 799.98 99.506 811.466 103.204C816.275 104.752 816.796 114.039 817.226 117.979C817.56 121.046 816.937 123.958 817.483 126.968C818.237 131.137 819.422 135.273 820.385 139.399C822.877 150.077 825.378 160.821 825.937 171.77C825.983 172.655 826.014 173.545 826.028 174.434Z",
    fill: "#372419"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M816.027 168.262L824.76 190.771C824.76 190.771 825.381 198.697 836.974 199.891C858.627 202.123 876.962 179.102 876.962 179.102L849.391 133.353L816.027 168.262Z",
    fill: "#ED8E6E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M873.66 169.712C873.424 169.864 839.396 200.098 839.396 200.098L824.153 189.012L817.73 197.939L829.145 219.398L839.709 204.831L858.177 216.181L880.161 177.196L873.66 169.712Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M817.73 197.938L829.143 219.396L839.707 204.829L858.177 216.181L880.161 177.196",
    stroke: "#231F20",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M848.526 119.258C844.707 104.596 836.641 98.1261 821.28 94.5664C800.899 89.8454 782.019 100.08 782.665 119.755C783.337 140.292 790.89 161.665 798.539 171.269C802.933 176.786 811.657 180.022 817.137 179.02C829.192 176.815 839.17 163.204 844.681 151.78C849.897 140.967 851.512 130.724 848.526 119.258Z",
    fill: "#ED8E6E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M841.457 144.021C845.038 149.595 849.137 154.826 854.292 158.945C860.633 164.007 869.695 167.014 869.695 167.014C869.695 167.014 874.368 159.729 874.269 153.081C874.198 148.303 873.397 145.513 872.018 140.894C866.472 122.321 862.234 94.961 845.363 83.3286C837.171 77.6816 831.818 77.4068 821.869 77.5222C816.742 77.5814 804.003 80.3001 799.265 82.2614C792.577 85.0287 787.072 90.2977 783.431 96.5503C779.79 102.803 777.94 109.997 777.428 117.213C777.181 120.705 777.25 124.293 778.443 127.584C780.075 132.088 782.967 137.401 785.855 141.254C784.537 135.299 784.104 130.019 786.212 124.249C786.864 122.464 791.163 119.688 792.6 118.441C794.413 116.869 796.967 116.491 799.368 116.486C804.059 116.476 807.884 118.281 812.291 119.261C816.579 120.216 820.988 120.008 825.149 121.649C832.358 124.492 834.396 132.053 837.983 138.283C839.097 140.216 840.248 142.137 841.457 144.021Z",
    fill: "#372419"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M819.895 178.37C819.895 178.37 828.94 175.41 834.301 166.577",
    stroke: "#231F20",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M817.752 141.62C818.115 143.156 817.535 144.607 816.458 144.862C815.38 145.116 814.213 144.076 813.85 142.54C813.487 141.003 814.068 139.552 815.144 139.299C816.223 139.044 817.39 140.084 817.752 141.62Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M795.439 147.599C795.802 149.135 795.222 150.587 794.145 150.842C793.069 151.095 791.901 150.055 791.538 148.519C791.175 146.983 791.755 145.532 792.832 145.278C793.909 145.023 795.076 146.063 795.439 147.599Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M800.875 141.075C801.49 143.581 801.659 151.588 802.049 154.126C802.465 156.825 804.816 156.645 808.388 155.821",
    stroke: "#231F20",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M806.518 163.515C806.651 165.252 808.223 166.119 810.217 165.683C812.119 165.269 814.675 163.754 813.262 162.009C812.779 161.413 811.994 161.036 811.173 160.816C810.348 160.596 809.428 160.519 808.586 160.783C807.304 161.184 806.43 162.387 806.518 163.515Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M822.69 132.849C817.742 130.212 809.217 131.261 807.574 134.734",
    stroke: "#231F20",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M794.466 137.89C791.374 136.234 787.656 137.208 785.805 140.161",
    stroke: "#231F20",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M827.582 138.271C828.548 134.517 831.701 130.936 835.892 131.448C840.389 131.996 843.168 136.899 843.777 140.969C844.441 145.398 843.634 151.869 838.638 153.463C835.841 154.356 832.588 153.207 831.509 150.353",
    fill: "#ED8E6E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M843.814 146.104C843.038 153.723 835.052 156.153 831.512 150.351",
    stroke: "#231F20",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M827.582 138.271C828.548 134.517 831.701 130.936 835.892 131.448",
    stroke: "#231F20",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M831.598 146.069L838.034 137.157",
    stroke: "#231F20",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M855.304 93.4202C831.354 104.675 804.631 110.64 777.312 113.435L776.258 130.566C815.945 127.604 839.843 116.213 859.845 101.963L855.304 93.4202Z",
    fill: "#FFBF66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M855.551 93.8362C857.659 95.2312 859.487 100.002 860.072 102.458",
    stroke: "#231F20",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M859.547 90.1853C860.844 89.7573 861.685 90.9231 862.101 91.9811C863.176 94.709 864.13 98.7362 863.43 101.69",
    stroke: "#231F20",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M868.812 98.8608C879.18 104.55 886.622 115.193 887.831 126.062",
    stroke: "#231F20",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M867.914 101.333C875.024 111.738 878.226 124.741 876.753 137.243",
    stroke: "#231F20",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M869.918 95.6821C874.208 96.8662 878.126 99.4817 881.639 102.292C893.898 112.098 902.796 125.187 906.149 138.353",
    stroke: "#231F20",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M824.758 114.665C836.456 109.968 847.433 103.486 857.187 95.512",
    stroke: "#231F20",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M907.868 243.092L873.555 248.884L874.522 254.609L908.835 248.817L907.868 243.092Z",
    stroke: "#231F20",
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask16_1623_36489",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -6,
    y: -145,
    width: 1139,
    height: 759
  }, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M1133 -145H-6V614H1133V-145Z",
    fill: "white"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask16_1623_36489)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M517.644 75.1025C512.762 72.6084 507.128 71.6733 502.611 72.5325C495.909 73.8091 489.841 76.622 484.264 79.2709C476.089 83.1539 452.334 96.5032 452.334 96.5032L432.836 76.7616C432.836 76.7616 450.223 66.8688 470.219 61.8276C479.348 59.5263 487.593 58.2178 498.515 59.8739C505.562 60.9426 512.628 64.6192 517.813 69.5238",
    fill: "#EF750D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.629 76.6919C473.068 69.5466 490.974 65.785 508.9 65.7122",
    stroke: "#231F20",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M517.64 68.9197C515.986 62.1813 511.871 56.2216 506.777 51.5067C501.684 46.7933 495.632 43.2336 489.431 40.1141C473.722 32.2129 455.967 26.8498 438.612 29.6824L438.293 55.2258C455.424 51.9378 473.402 53.1765 489.917 58.784C498.836 61.8124 507.602 66.3088 513.484 73.6619",
    fill: "#EF750D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M489.918 58.7825C495.932 59.88 500.126 62.3133 503.659 63.9012",
    stroke: "#231F20",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454.074 37.5002C473.468 39.8182 492.173 48.4602 506.52 61.7336",
    stroke: "#231F20",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M553.043 135.07L540.763 168.028C540.763 168.028 535.786 179.435 516.674 175.699C490.194 170.524 483.5 147.947 483.5 147.947L511.097 102.739L553.043 135.07Z",
    fill: "#ED8E6E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M511.538 88.7768C516.255 73.0488 525.023 66.4561 541.296 63.4231C562.887 59.4004 582.175 71.5505 580.541 92.8981C578.836 115.181 576.005 139.932 565.628 149.146C547.673 165.09 521.574 142.827 513.983 124.331C509.044 112.297 507.85 101.076 511.538 88.7768Z",
    fill: "#ED8E6E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M581.615 74.978C581.934 76.3184 582.135 77.6861 582.199 79.072C582.288 81.0287 582.095 82.9854 581.866 84.93C581.483 88.18 585.117 98.4478 579.315 105.725C580.145 95.9507 577.965 87.4347 574.98 85.1653C572.402 83.204 568.017 81.2246 564.682 81.771C560.851 82.398 556.702 84.5384 553.118 86.0124C550.814 86.9596 549.477 88.3971 547.404 89.5857C544.639 91.1705 541.793 90.322 538.986 91.3481C534.604 92.8525 530.01 97.8452 526.556 100.836C518.597 107.73 511.184 115.296 502.564 121.398C502.062 121.754 501.481 122.123 500.877 122.006C500.39 121.912 500.021 121.524 499.693 121.151C485.851 105.393 486.825 81.4371 499.418 65.2613C502.034 61.8989 502.745 59.2834 506.294 56.6072C524.772 42.6765 550.547 43.8651 569.144 57.392C574.901 61.5817 579.925 67.892 581.615 74.978Z",
    fill: "#222021"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M545.945 154.122C537.833 152.73 530.593 148.689 525.156 142.37",
    stroke: "#231F20",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M547.615 112.356C547.258 113.974 547.89 115.488 549.023 115.736C550.158 115.985 551.365 114.877 551.722 113.261C552.079 111.642 551.447 110.129 550.314 109.88C549.18 109.63 547.972 110.739 547.615 112.356Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M572.404 116.278C572.048 117.896 572.679 119.41 573.812 119.659C574.947 119.909 576.154 118.8 576.511 117.183C576.868 115.566 576.236 114.051 575.103 113.802C573.969 113.552 572.761 114.66 572.404 116.278Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M562.484 109.655C562.013 112.723 562.927 122.209 562.762 125.277C562.587 128.538 558.966 128.656 554.855 127.194",
    stroke: "#231F20",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M539.32 104.089C543.494 101.037 552.214 101.004 555.228 105.845",
    stroke: "#231F20",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M571.762 108.995C573.871 107.119 578.089 106.736 579.01 109.948",
    stroke: "#231F20",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M582.385 79.4805C565.298 80.03 543.522 75.9708 527.233 70.7869C518.171 67.9027 509.859 64.3672 502.559 59.6873L496.191 68.6768C496.191 68.6768 507.302 80.9377 529.271 88.4412C545.961 94.1413 565.004 98.0274 582.634 98.5192C583.211 92.7721 583.606 82.9673 582.385 79.4805Z",
    fill: "#EF750D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M557.322 111.56C556.203 118.801 549.949 123.741 543.354 122.595C536.758 121.449 532.319 114.651 533.438 107.41C534.558 100.171 540.811 95.2298 547.407 96.3758C554.003 97.5219 558.442 104.32 557.322 111.56Z",
    stroke: "#31212F",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M584.721 117.31C583.602 124.55 578.412 129.676 573.13 128.758C567.848 127.839 564.474 121.227 565.593 113.986C566.713 106.747 571.902 101.62 577.184 102.539C582.466 103.457 585.84 110.071 584.721 117.31Z",
    stroke: "#31212F",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M567.369 108.561L557.348 107.222",
    stroke: "#31212F",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M534.952 103.539L515.348 102.873",
    stroke: "#31212F",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M527.106 105.892C524.772 101.481 519.751 97.9424 514.656 99.8384C509.192 101.871 507.181 108.842 507.637 114.12C508.133 119.865 511.081 127.724 517.816 128.223C521.587 128.503 525.314 126.091 525.807 122.194",
    fill: "#ED8E6E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M509.133 120.561C512.387 129.866 523.115 130.517 525.809 122.195",
    stroke: "#231F20",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M527.106 105.892C524.772 101.481 519.751 97.9424 514.656 99.8384",
    stroke: "#231F20",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M524.417 116.858L513.688 107.627",
    stroke: "#231F20",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M575.529 84.2272C553.129 85.7239 530.321 80.4701 511.11 69.246C507.503 67.139 504.023 64.8256 500.695 62.3179",
    stroke: "#231F20",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M549.186 135.984C550.635 137.497 553.672 138.297 555.191 137.673C558.049 136.498 555.944 132.181 553.701 131.457C552.322 131.012 550.714 131.176 549.409 132.261C549.048 132.562 548.703 132.948 548.522 133.444C548.176 134.399 548.504 135.27 549.186 135.984Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M561.805 265.586C561.805 265.586 579.271 299.027 589.663 321.717C606.897 359.34 648.284 419.034 648.284 419.034L703.607 410.055L641.328 292.837L611.836 222.059",
    fill: "#ED8E6E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M542.512 165.237C554.321 167.326 566.118 170.342 576.647 176.08C590.307 183.526 599.501 189.529 607.672 205.08C614.907 218.848 629.27 258.257 629.27 258.257L571.827 291.378L543.333 242.432",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M621.987 238.902L562.137 274.73",
    stroke: "#231F20",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.075 200.596C405.347 263.549 396.431 327.801 393.473 392.311L573.403 393.711C573.403 393.711 577.105 288.331 581.519 216.134L541.131 162.286L527.261 172.203L476.308 148.288L420.075 200.596Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M489.058 135.496L528.883 168.689L544.689 157.492L548.093 167.857L538.192 187.885L528.323 176.74L511.364 188.576L476.867 147.529L489.058 135.496Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M548.093 167.857L538.192 187.885L528.323 176.74L511.364 188.576L476.867 147.529",
    stroke: "#231F20",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M577.312 295.51C577.312 295.51 578.41 275.677 579.689 257.868C580.467 247.028 582.575 237.478 587.302 228.66",
    stroke: "#231F20",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M523.051 180.421L504.324 393.175",
    stroke: "#231F20",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M532.944 181.633L514.348 392.884",
    stroke: "#231F20",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M578.953 263.268L549.395 261.177L548.918 267.907L578.476 269.998L578.953 263.268Z",
    stroke: "#231F20",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M516.258 179.482L515.184 178.29C514.495 177.524 514.685 176.226 515.608 175.389L516.616 174.475C517.54 173.639 518.847 173.583 519.537 174.349L520.609 175.541L521.102 175.095L575.509 235.569L570.168 240.404L515.761 179.93L516.258 179.482Z",
    fill: "#28243E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M576.871 241.786C576.938 242.108 576.576 242.435 576.265 242.334L570.172 240.402L575.577 235.51L576.871 241.786Z",
    fill: "#28243E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M515.766 179.93L521.107 175.095",
    stroke: "#5F558A",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M570.172 240.404L575.577 235.511",
    stroke: "#5F558A",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M533.113 199.205L538.379 194.287",
    stroke: "#5F558A",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M476.309 148.288C476.309 148.288 463.671 149.481 451.664 150.676C444.686 151.371 440.487 152.46 434.238 155.64C417.519 164.147 407.337 181.781 401.516 199.607C395.695 217.433 390.254 247.44 390.254 247.44L461.455 262.718L471.418 202.302",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.012 228.771L464.643 243.379",
    stroke: "#231F20",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461.453 262.718L471.416 202.302",
    stroke: "#231F20",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M496.34 231.584L441.8 258.501L391.64 247.737C391.64 247.737 387.584 265.976 385.606 286.262C384.082 301.896 388.603 325.014 402.374 332.59C414.971 339.52 433.22 338.498 454.302 323.951C482.838 304.26 519.749 268.852 519.749 268.852L496.34 231.584Z",
    fill: "#ED8E6E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.799 258.501C441.799 258.501 428.512 264.79 415.465 273.068C410.025 276.52 402.461 289.359 402.461 289.359",
    stroke: "#231F20",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M481.715 240.621C492.695 233.77 504.185 220.671 513.862 212.079C516.217 209.987 518.663 207.961 521.425 206.447C526.857 203.472 533.176 202.648 539.339 202.031C544.052 201.561 549.103 201.714 553.429 203.888C554.476 204.415 555.426 205.113 556.345 205.839C557.19 206.505 558.017 207.202 558.725 208.011C560.025 209.497 566.92 219.25 567.354 219.719C567.788 220.19 568.115 220.805 568.069 221.442C567.99 222.54 566.885 223.267 565.835 223.599C564.01 224.178 562.039 224.1 560.145 223.818C560.866 223.926 558.178 228.6 557.879 228.269C560.227 230.867 559.378 235.613 556.274 237.235C558.602 242.444 556.344 248.449 554.096 253.692C553.516 255.046 552.817 256.52 551.464 257.101C549.487 257.949 547.265 256.402 546.077 254.609C544.282 251.899 545.08 248.681 545.926 245.543C545.093 244.118 541.49 243.916 540.225 244.974C538.958 246.032 538.408 247.694 537.878 249.256C536.806 252.415 535.582 255.523 534.211 258.562C533.044 261.145 531.734 263.737 529.691 265.702C527.855 267.469 525.528 268.632 523.196 269.663C516.175 272.764 508.735 274.915 501.142 276.035",
    fill: "#ED8E6E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M516.306 271.841C513.982 272.697 511.692 273.643 509.441 274.672",
    stroke: "#231F20",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M556.267 237.05C554.903 235.303 552.835 234.281 550.829 233.339C548.622 232.301 546.385 231.282 544.01 230.725C541.635 230.169 539.089 230.099 536.801 230.942",
    stroke: "#231F20",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M557.919 228.226C555.376 225.694 552.59 223.373 549.435 221.659C546.282 219.947 542.741 218.859 539.152 218.88",
    stroke: "#231F20",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M540.195 208.287C543.826 208.746 547.354 209.968 550.527 211.823C552.601 213.036 554.41 214.61 556.035 216.372C558.181 218.701 559.721 220.988 560.667 224.026",
    stroke: "#231F20",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M555.205 250.996C554.249 250.667 552.786 250.16 551.829 249.829C551.109 249.58 550.251 249.363 549.656 249.931C549.238 250.328 549.096 250.989 548.992 251.602C548.886 252.238 548.801 252.918 549.017 253.502C549.322 254.331 550.125 254.712 550.877 254.922C551.773 255.172 552.958 255.55 552.958 255.55",
    stroke: "#231F20",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M563.95 215.618C563.353 215.982 562.76 216.352 562.169 216.729C561.654 217.057 561.11 217.427 560.898 217.999C560.749 218.397 560.784 218.848 560.919 219.25C561.33 220.484 562.63 221.278 563.927 221.371C565.226 221.463 566.503 220.96 567.601 220.26",
    stroke: "#231F20",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M607.977 305.483C616.095 302.337 624.471 299.849 632.99 298.05",
    stroke: "#231F20",
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask17_1623_36489",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -6,
    y: -145,
    width: 1139,
    height: 759
  }, _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M1133 -145H-6V614H1133V-145Z",
    fill: "white"
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask17_1623_36489)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M181.818 102.287C178.159 105.951 175.544 110.842 174.777 115.311C173.64 121.945 173.977 128.518 174.34 134.578C174.872 143.464 178.126 169.99 178.126 169.99L155.443 181.282C155.443 181.282 152.962 161.824 155.338 141.612C156.424 132.384 158.04 124.313 162.982 114.777C166.17 108.624 171.518 103.345 177.265 100.224",
    fill: "#FFBF66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.168 159.256C162.646 141.612 165.396 123.772 171.199 107.167",
    stroke: "#231F20",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.71 100.18C170.603 99.4085 164.334 101.18 158.774 104.281C153.215 107.383 148.296 111.764 143.691 116.433C132.026 128.263 121.789 142.852 118.449 159.869L139.442 168.883C142.33 151.919 149.234 135.715 159.268 122.355C164.687 115.14 171.267 108.568 179.266 105.638",
    fill: "#FFBF66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.27 122.356C162.143 117.169 165.525 114.121 167.991 111.396",
    stroke: "#231F20",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.965 148.241C138.223 131.097 151.48 116.749 167.136 108.013",
    stroke: "#231F20",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.879 152.866L246.703 185.132C246.703 185.132 244.251 196.43 226.156 196.51C201.089 196.623 190.871 177.273 190.871 177.273L207.768 131.057L251.879 152.866Z",
    fill: "#ED8E6E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.458 128.834C185.008 113.244 188.793 103.096 200.713 91.9203C216.528 77.091 239.038 76.9377 249.043 95.562C259.485 115.003 270.307 137.093 266.582 150.275C260.135 173.086 226.579 168.449 210.418 157.105C199.903 149.721 192.937 141.023 189.458 128.834Z",
    fill: "#ED8E6E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.095 70.6531C253.91 75.034 260.141 84.6794 259.362 94.4903C259 99.0412 255.342 107.504 255.342 107.504C255.342 107.504 252.417 102.76 251.911 102.023C250.669 100.206 249.287 98.4704 247.756 96.8872C245.856 94.9229 243.195 92.3256 240.295 92.0903C237.106 91.8307 232.405 92.5169 229.922 94.7438C227.07 97.3031 224.759 101.289 222.561 104.423C221.15 106.435 220.803 108.342 219.711 110.434C218.254 113.222 215.436 114.03 213.648 116.377C210.804 119.959 209.64 126.555 208.36 130.878C205.409 140.847 202.472 156.754 196.428 162.066C176.527 156.32 164.99 135.875 166.852 115.726C167.186 112.11 167.136 108.907 168.406 105.417C169.692 101.884 171.642 98.6223 173.82 95.5711C176.825 91.3586 180.351 87.4224 184.74 84.6809C190.463 81.106 197.282 79.7778 203.97 78.87C205.703 78.6348 207.472 78.4146 209.053 77.6663C210.492 76.9847 211.697 75.9039 212.948 74.9187C221.296 68.3564 233.046 65.92 242.963 69.7165C243.69 69.9943 244.401 70.307 245.095 70.6531Z",
    fill: "#222021"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.859 164.881C245.371 168.039 237.199 168.528 229.312 166.163",
    stroke: "#231F20",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.963 128.832C232.527 130.367 233.858 131.29 234.933 130.895C236.01 130.499 236.424 128.935 235.859 127.401C235.294 125.866 233.964 124.943 232.889 125.338C231.814 125.732 231.399 127.297 231.963 128.832Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.666 123.294C254.231 124.829 255.561 125.752 256.636 125.357C257.713 124.961 258.128 123.398 257.563 121.863C256.998 120.328 255.667 119.405 254.592 119.8C253.517 120.195 253.102 121.76 253.666 123.294Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.77 120.735C247.587 123.155 251.9 129.661 252.947 131.954C254.062 134.392 251.382 135.965 247.728 136.593",
    stroke: "#231F20",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.428 83.4209C229.51 92.9646 209.237 101.172 192.929 105.524C183.857 107.946 175.062 109.426 166.499 109.417L165.988 120.281C165.988 120.281 181.755 124.569 204.022 119.126C220.937 114.991 238.845 108.093 253.769 99.1261C251.192 94.0363 246.301 85.6721 243.428 83.4209Z",
    fill: "#FFBF66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.037 133.079C209.219 129.964 203.292 128.674 199.387 132.355C195.199 136.304 196.049 143.415 198.494 148.041C201.155 153.074 206.858 159.092 213.174 156.959C216.711 155.766 219.174 152.139 218.125 148.405",
    fill: "#ED8E6E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.328 153.323C208.866 160.537 218.872 157.008 218.124 148.405",
    stroke: "#231F20",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.036 133.079C209.219 129.964 203.291 128.674 199.387 132.355",
    stroke: "#231F20",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.807 144.086L201.5 139.81",
    stroke: "#231F20",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.254 91.0156C222.419 104.174 200.654 111.935 178.701 112.819C174.58 112.984 170.453 112.911 166.352 112.597",
    stroke: "#231F20",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.947 141.545C248.563 141.354 246.888 142.553 247.11 145.207C247.151 145.689 247.301 146.2 247.681 146.5C247.914 146.685 248.211 146.772 248.504 146.823C250.18 147.121 252.455 146.347 253.614 145.041C255.327 143.11 253.095 141.817 251.275 141.582C251.164 141.565 251.055 141.554 250.947 141.545Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.305 113.42C250.766 112.341 252.309 111.339 254.016 110.718C255.723 110.095 257.618 109.874 259.366 110.37",
    stroke: "#231F20",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.762 123.874C224.492 119.291 230.583 116.743 236.466 117.301",
    stroke: "#231F20",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.156 186.915C256.079 186.513 270.996 192.697 283.118 198.894C293.575 204.239 301.778 217.512 310.108 230.298C322.264 248.959 331.578 264.757 331.578 264.757L265.507 303.985L237.746 252.274",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.27 287.31L322.25 250.267",
    stroke: "#231F20",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.863 302.584C267.863 302.584 280.382 324.938 291.987 341.256C301.898 355.191 314.289 364.668 333.757 362.337C352.986 360.034 360.958 338.134 366.053 308.185C371.148 278.236 374.117 221.242 374.117 221.242L329.29 219.082L308.791 278.282",
    fill: "#ED8E6E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.087 176.752C182.613 178.443 136.362 195.17 128.479 206.856C108.534 236.422 113.248 270.827 111.005 304.336C108.859 336.368 105.639 368.322 101.826 400.2C101.392 403.831 185.145 404.662 192.701 404.261C221.439 402.738 253.225 401.072 280.123 390.418C280.123 390.418 282.729 248 281.909 241.146C281.089 234.292 246.483 185.358 246.483 185.358L239.37 193.711L191.087 176.752Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.633 296.68C281.633 296.68 282.063 253.868 286.913 241.049",
    stroke: "#231F20",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.635 279.993C302.935 295.75 299.966 312.49 299.902 329.246",
    stroke: "#231F20",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.756 201.956L233.359 401.226",
    stroke: "#231F20",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.302 201.052L243.059 400.067",
    stroke: "#231F20",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.456 169.816L238.892 189.74L247.506 178.968L257.921 187.463L251.984 207.619L239.852 197.755L225.415 212.562L183.828 178.713L193.456 169.816Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.921 187.463L251.984 207.619L239.852 197.755L225.415 212.562L183.828 178.713",
    stroke: "#231F20",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.268 261.513L254.18 261.534L254.585 255.928L283.675 255.905L283.268 261.513Z",
    stroke: "#231F20",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.873 182.654C374.217 189.76 375.916 196.72 377.464 203.665C378.414 207.93 378.36 211.435 377.963 215.788C377.318 222.88 374.246 230.084 369.573 235.458L327.273 225.342L327.047 181.56C328.292 177.543 332.095 174.964 335.644 172.707C338.564 170.849 341.483 168.992 344.404 167.134C346.752 165.64 348.984 163.514 351.836 163.107C353.739 162.835 355.71 163.342 357.352 164.343C358.992 165.344 360.313 166.817 361.3 168.465C361.174 168.253 362.886 167.653 363.061 167.621C365.381 167.201 368.754 168.297 370.084 170.064C370.326 170.384 371.292 172.06 371.705 173.18C373.366 172.045 375.781 173.097 377.151 174.569C378.522 176.043 379.359 178.683 379.523 181.174C379.775 185.037 379.055 188.769 378.249 191.197C377.953 192.09 377.049 192.723 376.144 192.981C374.422 193.471 372.754 192.158 371.442 190.941C367.413 193.522 361.474 192.465 358.583 188.653C359.144 189.393 355.856 190.115 355.523 190.106C353.759 190.057 351.415 189.324 350.017 188.199C347.541 186.209 346.779 183.671 346.137 180.561",
    fill: "#ED8E6E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.397 184.672C323.763 178.53 326.115 174.815 328.87 169.346C331.396 164.334 334.345 155.517 338.873 152.074C340.807 150.605 343.425 149.808 345.709 150.635C349.96 152.174 351.556 157.597 354.207 160.835C356.095 163.139 361.101 166.577 359.542 170.15C358.46 172.632 354.583 173.155 352.238 172.856C348.195 172.339 343.982 169.903 341.142 167.034",
    fill: "#ED8E6E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.206 160.833C356.093 163.137 361.099 166.576 359.541 170.149C358.458 172.631 354.581 173.153 352.236 172.854C348.193 172.338 343.981 169.902 341.141 167.033",
    stroke: "#231F20",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.346 163.039C355.497 163.591 354.575 164.034 353.614 164.352C353.091 164.525 352.529 164.678 352.16 165.085C351.527 165.783 351.784 166.988 352.513 167.588C353.24 168.186 354.271 168.28 355.202 168.128C356.595 167.901 357.899 167.172 358.821 166.105",
    stroke: "#231F20",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.731 174.908C349.58 177.618 349.405 180.327 349.206 183.034C349.151 183.772 349.094 184.521 348.823 185.208C348.728 185.452 348.603 185.693 348.591 185.956C348.582 186.147 348.633 186.337 348.691 186.519C349.056 187.673 349.698 188.735 350.541 189.604C351.353 190.44 352.193 190.66 353.302 190.941C355.531 191.506 358.222 191.128 360.029 189.818C360.333 190.616 360.986 191.29 361.723 191.87C362.93 192.823 364.645 193.601 366.344 193.194C367.662 192.878 369.444 191.056 369.444 191.056C369.444 191.056 369.998 192.174 370.964 192.79C371.928 193.406 374.065 193.969 375.332 193.819",
    stroke: "#231F20",
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.883 190.074C362.621 183.219 363.268 175.544 361.714 168.326",
    stroke: "#231F20",
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.574 191.293C372.214 185.737 372.976 179.249 371.702 173.18",
    stroke: "#231F20",
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.895 141.966C310.895 141.966 307.025 144.263 308.899 145.882C309.526 146.426 315.924 151.956 316.984 152.871C318.045 153.786 320.704 154.433 322.156 155.689C323.607 156.944 322.813 158.347 322.813 158.347",
    stroke: "#5F558A",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.297 140.54L307.023 139.44C306.204 138.732 306.23 137.356 307.082 136.364L308.013 135.28C308.865 134.289 310.218 134.057 311.037 134.764L312.311 135.865L312.767 135.335L377.372 191.134L372.449 196.87L307.843 141.072L308.297 140.54Z",
    fill: "#28243E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.603 197.429C379.714 197.754 379.381 198.142 379.044 198.08L372.445 196.87L377.428 191.065L379.603 197.429Z",
    fill: "#28243E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.84 141.072L312.763 135.335",
    stroke: "#5F558A",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.449 196.87L377.43 191.065",
    stroke: "#5F558A",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.445 158.856L333.279 153.042",
    stroke: "#5F558A",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.506 228.653C327.889 210.499 322.8 203.671 321.565 189.79C321.28 186.572 320.598 183.202 321.869 180.23C323.304 176.877 326.653 174.847 329.462 172.52C332.3 170.17 334.732 167.33 336.618 164.165C337.336 162.96 338.105 161.6 339.446 161.19C341.546 160.548 343.493 162.658 344.243 164.721C345.563 168.353 345.063 172.598 342.937 175.825C341.422 178.126 339.063 180.125 338.85 182.871C338.565 186.566 342.187 189.168 344.511 192.057C348.663 197.219 348.767 205.23 344.752 210.499",
    fill: "#ED8E6E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.867 180.232C323.302 176.878 326.651 174.849 329.461 172.522C332.299 170.172 334.73 167.332 336.616 164.167C337.335 162.961 338.103 161.601 339.444 161.191C341.545 160.549 343.491 162.659 344.242 164.722C345.561 168.355 345.062 172.599 342.936 175.826C341.42 178.128 339.062 180.127 338.849 182.873C338.563 186.568 342.185 189.169 344.509 192.058C348.661 197.221 352.487 208.553 352.439 218.227",
    stroke: "#231F20",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.926 167.19C336.08 168.001 337.234 168.813 338.387 169.624C338.613 169.783 338.844 169.944 339.11 170.025C339.649 170.187 340.247 169.979 340.674 169.612C341.335 169.044 341.635 168.15 341.699 167.282C341.74 166.72 341.687 166.126 341.383 165.651C341.041 165.117 340.443 164.815 339.871 164.539C339.093 164.162 338.314 163.79 337.533 163.418",
    stroke: "#231F20",
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask18_1623_36489",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -6,
    y: -145,
    width: 1139,
    height: 759
  }, _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M1133 -145H-6V614H1133V-145Z",
    fill: "white"
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask18_1623_36489)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M971.695 375.678H105.063C96.6966 375.678 88.8344 379.68 83.914 386.444L-79.9335 611.633C-84.33 617.675 -80.0124 626.15 -72.5376 626.15H1149.3C1156.77 626.15 1161.09 617.675 1156.69 611.633L992.845 386.444C987.923 379.68 980.062 375.678 971.695 375.678Z",
    fill: "#FFBF66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.848 375.678C100.554 375.678 92.7605 379.712 87.8825 386.528L-69.9768 613.463C-74.3339 619.551 -70.0543 628.091 -62.6462 628.091H1139.41C1146.81 628.091 1151.09 619.551 1146.74 613.463L988.879 386.528C984.001 379.712 976.207 375.678 967.913 375.678",
    stroke: "#292944",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.562 567.085L138.787 588.712L112.078 483.097L208.492 468.026L251.562 567.085Z",
    fill: "#FFF4E9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.792 548.389L67.4062 555.237L73.9426 456.646L159.942 457.403L182.792 548.389Z",
    fill: "#FFE4E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.0039 499.93L164.998 499.512",
    stroke: "#EDC0C0",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.0039 491.277L163.114 490.86",
    stroke: "#EDC0C0",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.8242 482.614L161.395 482.197",
    stroke: "#EDC0C0",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.8242 473.951L159.515 473.533",
    stroke: "#EDC0C0",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.8242 465.189L158.001 464.872",
    stroke: "#EDC0C0",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M688.916 393.348L644.184 476.741L644.949 480.384L847.521 494.588L851.506 408.574L850.624 405.703L688.916 393.348Z",
    fill: "#EF750D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M645.16 467.8L684.614 399.797L769.843 394.944L744.888 475.8L645.16 467.8Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M841.527 481.762L843.136 489.393L849.344 406.822L847.994 400.422L841.527 481.762Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M744.888 475.8C744.888 475.8 733.894 471.429 705.72 469.454C687.932 468.207 645.16 467.8 645.16 467.8L646.811 475.628L746.323 482.605L744.888 475.8Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M841.527 481.763C841.527 481.763 800.71 472.545 778.396 472.308C756.084 472.072 744.887 475.8 744.887 475.8L746.322 482.605L843.135 489.394L841.527 481.763Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M742.551 387.452C716.407 385.247 688.826 389.413 688.826 389.413L645.16 467.798C645.16 467.798 683.821 462.809 713.887 466.827C736.256 469.816 744.888 475.798 744.888 475.798L769.843 394.94C769.841 394.943 760.432 388.961 742.551 387.452Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M847.994 400.422L841.527 481.762C841.527 481.762 808.536 474.903 774.173 473.389C759.607 472.747 744.887 475.8 744.887 475.8L769.841 394.942C769.841 394.942 777.53 392.513 792.579 392.774C807.626 393.037 847.994 400.422 847.994 400.422Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M745.59 479.138L769.841 394.944",
    stroke: "#292944",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M645.16 467.8C645.16 467.8 683.821 462.81 713.887 466.828C736.256 469.817 745.591 479.136 745.591 479.136C745.591 479.136 756.084 472.071 778.397 472.308C800.711 472.545 841.528 481.762 841.528 481.762L847.995 400.422",
    stroke: "#292944",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M645.746 470.579C645.746 470.579 689.686 469.597 706.499 471.045C733.126 473.341 745.592 479.138 745.592 479.138C745.592 479.138 757.5 475.795 778.713 476.451C799.926 477.107 842.073 484.345 842.073 484.345",
    stroke: "#292944",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M841.527 481.762L843.227 489.82",
    stroke: "#292944",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M646.355 473.479C646.355 473.479 703.476 474.449 715.072 475.262C733.36 476.545 745.868 480.457 745.868 480.457C745.868 480.457 769.327 479.07 780.176 479.827C791.025 480.586 842.681 487.244 842.681 487.244",
    stroke: "#292944",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M761.332 463.424C761.332 463.424 773.812 458.886 789.239 459.969C804.666 461.049 835.021 467.009 835.021 467.009",
    stroke: "#EDD9C5",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M765.316 448.316C765.316 448.316 777.366 444.411 792.145 445.446C806.925 446.483 835.941 451.881 835.941 451.881",
    stroke: "#EDD9C5",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M769.469 436.521C769.469 436.521 781.017 432.773 795.181 433.766C809.346 434.759 837.156 439.937 837.156 439.937",
    stroke: "#EDD9C5",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M771.57 426.545C771.57 426.545 783.047 423.782 796.891 424.752C810.735 425.722 837.781 430.144 837.781 430.144",
    stroke: "#EDD9C5",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M773.082 417.668C773.082 417.668 784.349 414.89 797.956 415.845C811.563 416.8 838.155 421.19 838.155 421.19",
    stroke: "#EDD9C5",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M776.223 409.873C776.223 409.873 787.288 407.781 800.495 408.709C813.705 409.635 839.428 413.468 839.428 413.468",
    stroke: "#EDD9C5",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M777.324 403.443C777.324 403.443 788.193 401.331 801.223 402.245C814.254 403.159 839.725 407.216 839.725 407.216",
    stroke: "#EDD9C5",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M661.75 453.781C661.75 453.781 694.073 451.89 707.451 452.808C729.012 454.287 738.51 460.243 738.51 460.243",
    stroke: "#EDD9C5",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M669.891 439.049C669.891 439.049 700.852 436.356 713.741 437.236C734.513 438.654 743.898 445.502 743.898 445.502",
    stroke: "#EDD9C5",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M676.824 427.133C676.824 427.133 706.74 425.964 719.074 426.814C738.95 428.182 747.55 432.941 747.55 432.941",
    stroke: "#EDD9C5",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M681.52 418.39C681.52 418.39 710.798 417.178 722.873 418.008C742.335 419.347 750.774 424.095 750.774 424.095",
    stroke: "#EDD9C5",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M728.102 411.717C745.059 413.164 753.878 415.981 753.878 415.981",
    stroke: "#EDD9C5",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M685.816 411.47C697.733 411.014 709.653 410.68 721.576 410.469",
    stroke: "#EDD9C5",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M710.066 403.488C725.417 402.851 741.248 402.285 755.643 407.648",
    stroke: "#EDD9C5",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M749.266 399.115L750.235 398.014C750.857 397.307 752.057 397.34 752.915 398.09L753.852 398.909C754.71 399.658 754.9 400.839 754.277 401.545L753.309 402.646L753.767 403.047L704.622 458.862L699.66 454.528L748.807 398.714L749.266 399.115Z",
    fill: "#28243E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M699.117 460.756C698.833 460.851 698.497 460.558 698.553 460.265L699.66 454.528L704.679 458.914L699.117 460.756Z",
    fill: "#28243E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M748.809 398.714L753.769 403.046",
    stroke: "#5F558A",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M699.66 454.528L704.679 458.914",
    stroke: "#5F558A",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M733.145 416.513L738.173 420.769",
    stroke: "#5F558A",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M586.542 393.758L620.744 485.609L619.383 489.589L415.113 498.304L425.278 403.573L426.629 400.446L586.542 393.758Z",
    fill: "#EF750D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M621.242 475.743L585.741 396.263L508.926 391.365L522.495 480.95L621.242 475.743Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.198 484.405L420.34 492.742L427.722 401.72L430.119 394.728L423.198 484.405Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M522.494 480.95C522.494 480.95 532.189 476.711 560.598 475.498C578.535 474.733 621.24 475.744 621.24 475.744L618.309 484.296L519.945 488.385L522.494 480.95Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.198 484.405C423.198 484.405 465.402 475.66 487.684 476.161C509.965 476.66 522.496 480.952 522.496 480.952L519.948 488.387L420.34 492.744L423.198 484.405Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M536.689 387.12C563.112 385.585 587.887 391.549 587.887 391.549L621.242 475.743C621.242 475.743 583.523 468.938 552.89 472.333C530.101 474.857 522.495 480.95 522.495 480.95L508.926 391.365C508.926 391.365 518.615 388.17 536.689 387.12Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.117 394.728L423.195 484.405C423.195 484.405 457.212 477.986 491.714 477.494C506.341 477.284 522.493 480.952 522.493 480.952L508.924 391.367C508.924 391.367 501.659 388.433 486.615 388.208C471.574 387.982 430.117 394.728 430.117 394.728Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M521.245 484.596L508.926 391.365",
    stroke: "#292944",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M621.24 475.743C621.24 475.743 583.521 468.938 552.888 472.332C530.099 474.857 521.243 484.596 521.243 484.596C521.243 484.596 509.963 476.66 487.681 476.161C465.399 475.661 423.195 484.405 423.195 484.405L430.117 394.728",
    stroke: "#292944",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M620.202 478.78C620.202 478.78 576.562 476.2 559.564 477.222C532.644 478.837 521.246 484.598 521.246 484.598C521.246 484.598 507.944 480.707 486.69 480.706C465.437 480.704 422.23 487.227 422.23 487.227",
    stroke: "#292944",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.197 484.405L420.18 493.208",
    stroke: "#292944",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M619.116 481.947C619.116 481.947 562.018 481.067 550.322 481.566C531.881 482.353 520.752 486.037 520.752 486.037C520.752 486.037 495.614 483.903 484.673 484.367C473.733 484.832 421.145 490.394 421.145 490.394",
    stroke: "#292944",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M506.153 466.97C506.153 466.97 494.456 461.555 478.9 462.218C463.344 462.882 432.105 468.401 432.105 468.401",
    stroke: "#EDD9C5",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M504.663 450.22C504.663 450.22 493.293 445.512 478.39 446.148C463.487 446.785 433.676 451.732 433.676 451.732",
    stroke: "#EDD9C5",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M502.462 437.106C502.462 437.106 491.567 432.59 477.283 433.199C462.999 433.807 434.426 438.553 434.426 438.553",
    stroke: "#EDD9C5",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M502.005 426.062C502.005 426.062 491.019 422.633 477.058 423.228C463.098 423.823 435.41 427.764 435.41 427.764",
    stroke: "#EDD9C5",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M501.959 416.249C501.959 416.249 491.184 412.81 477.463 413.395C463.741 413.981 436.512 417.902 436.512 417.902",
    stroke: "#EDD9C5",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M500.113 407.569C500.113 407.569 489.426 404.892 476.107 405.46C462.789 406.028 436.516 409.367 436.516 409.367",
    stroke: "#EDD9C5",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M500.07 400.46C500.07 400.46 489.582 397.767 476.443 398.329C463.303 398.889 437.246 402.482 437.246 402.482",
    stroke: "#EDD9C5",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M607.009 459.759C607.009 459.759 575.099 456.577 561.612 457.13C539.875 458.021 529.43 464.248 529.43 464.248",
    stroke: "#EDD9C5",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M601.316 443.279C601.316 443.279 570.895 439.263 557.902 439.791C536.961 440.643 526.48 447.853 526.48 447.853",
    stroke: "#EDD9C5",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M596.36 429.938C596.36 429.938 566.729 427.633 554.296 428.147C534.257 428.972 524.902 433.913 524.902 433.913",
    stroke: "#EDD9C5",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M593.115 420.163C593.115 420.163 564.128 417.832 551.954 418.333C532.335 419.142 523.141 424.075 523.141 424.075",
    stroke: "#EDD9C5",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M590.986 412.513C590.986 412.513 561.999 410.181 549.825 410.682C530.206 411.491 521.012 416.425 521.012 416.425",
    stroke: "#EDD9C5",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M587.925 403.359C587.925 403.359 559.411 401.666 547.426 402.166C528.108 402.97 519.023 407.068 519.023 407.068",
    stroke: "#EDD9C5",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M585.74 396.263C585.74 396.263 559.384 393.193 547.398 393.693C528.081 394.497 518.996 398.594 518.996 398.594",
    stroke: "#EDD9C5",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.934 391.076L405.207 476.525L404.95 480.565L202.848 514.926L183.336 422.602L183.817 419.395L345.934 391.076Z",
    fill: "#EF750D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.983 466.854L345.83 393.611L268.203 397.911L306.363 483.589L402.983 466.854Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.045 500.429L206.506 508.889L185.254 420.508L185.708 413.413L207.045 500.429Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.36 483.589C306.36 483.589 314.819 478.312 342.696 473.776C360.297 470.912 402.981 466.854 402.981 466.854L402.427 475.533L305.879 491.133L306.36 483.589Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.043 500.429C207.043 500.429 248.208 485.178 270.472 483.033C292.735 480.888 306.361 483.589 306.361 483.589L305.879 491.133L206.504 508.888L207.043 500.429Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.6 390.496C320.416 385.881 346.66 388.765 346.66 388.765L402.979 466.854C402.979 466.854 363.649 464.679 334.167 471.602C312.233 476.753 306.359 483.589 306.359 483.589L268.199 397.911C268.199 397.911 276.942 393.653 294.6 390.496Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.707 413.413L207.046 500.429C207.046 500.429 240.721 488.41 274.847 483.856C289.312 481.925 306.364 483.59 306.364 483.59L268.204 397.913C268.204 397.913 260.181 395.912 245.181 397.469C230.18 399.024 185.707 413.413 185.707 413.413Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.363 489.829L268.203 397.911",
    stroke: "#292944",
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.98 466.854C402.98 466.854 363.65 464.679 334.168 471.602C312.234 476.753 306.36 489.829 306.36 489.829C306.36 489.829 292.734 480.889 270.471 483.033C248.207 485.178 207.042 500.429 207.042 500.429L185.703 413.413",
    stroke: "#292944",
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.042 500.429L206.473 509.363",
    stroke: "#292944",
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.579 473.151C402.579 473.151 345.637 479.036 334.162 480.903C316.067 483.847 306.361 489.829 306.361 489.829C306.361 489.829 280.48 489.641 269.745 491.385C259.009 493.129 206.656 506.507 206.656 506.507",
    stroke: "#292944",
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.279 471.899C286.279 471.899 273.173 468.005 257.909 470.488C242.645 472.972 213.145 482.039 213.145 482.039",
    stroke: "#EDD9C5",
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.188 455.755C280.188 455.755 267.601 452.511 252.976 454.891C238.353 457.27 210.113 465.611 210.113 465.611",
    stroke: "#EDD9C5",
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.388 443.239C274.388 443.239 262.324 440.125 248.308 442.405C234.292 444.685 207.227 452.684 207.227 452.684",
    stroke: "#EDD9C5",
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.894 432.534C270.894 432.534 259.039 430.489 245.341 432.719C231.642 434.947 205.234 442.058 205.234 442.058",
    stroke: "#EDD9C5",
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.142 422.976C268.142 422.976 256.495 420.898 243.031 423.089C229.568 425.279 203.609 432.315 203.609 432.315",
    stroke: "#EDD9C5",
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.915 414.738C263.915 414.738 252.566 413.392 239.496 415.518C226.427 417.645 201.258 424.001 201.258 424.001",
    stroke: "#EDD9C5",
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.914 407.817C261.914 407.817 250.758 406.433 237.864 408.531C224.971 410.629 200.086 417.208 200.086 417.208",
    stroke: "#EDD9C5",
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.443 452.963C384.443 452.963 351.878 453.632 338.64 455.764C317.301 459.199 308.645 466.499 308.645 466.499",
    stroke: "#EDD9C5",
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.248 437.579C374.248 437.579 342.933 437.258 330.176 439.307C309.616 442.61 301.195 450.873 301.195 450.873",
    stroke: "#EDD9C5",
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.655 425.167C365.655 425.167 335.596 426.421 323.392 428.388C303.722 431.559 295.793 437.478 295.793 437.478",
    stroke: "#EDD9C5",
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.737 416.025C359.737 416.025 330.31 417.176 318.361 419.102C299.102 422.208 291.332 428.1 291.332 428.1",
    stroke: "#EDD9C5",
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.512 408.823C355.512 408.823 326.085 409.973 314.135 411.9C294.875 415.004 287.105 420.897 287.105 420.897",
    stroke: "#EDD9C5",
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.953 400.267C349.953 400.267 321.173 401.987 309.408 403.888C290.447 406.952 282.555 412.016 282.555 412.016",
    stroke: "#EDD9C5",
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.831 393.611C345.831 393.611 318.812 393.732 307.048 395.634C288.088 398.699 280.195 403.763 280.195 403.763",
    stroke: "#EDD9C5",
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.434 490.081C256.434 490.081 259.961 498.265 259.814 501.15C259.667 504.038 260.227 507.509 266.47 512.537C272.714 517.566 275.762 519.807 275.762 519.807L292.411 514.925C292.411 514.925 277.323 504.734 276.665 502.374C276.006 500.013 277.101 498.542 276.823 496.325C276.374 492.741 273.052 487.327 273.052 487.327",
    fill: "#BF5247"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.784 469.934C402.784 469.934 358.74 472.575 342.141 475.577C315.854 480.329 306.933 489.497 306.933 489.497C306.933 489.497 291.842 485.067 270.736 487.575C249.631 490.084 206.859 503.288 206.859 503.288",
    stroke: "#292944",
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M918.555 500.095L955.08 591.76V568.691L918.555 477.025V500.095Z",
    fill: "#A1A8CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M918.535 493.111L955.082 585.249V575.493L918.535 483.356V493.111Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1021.24 462.648L918.699 477.031L955.08 568.691L1069.78 552.601L1021.24 462.648Z",
    fill: "#BFC4E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M949.039 482.705L1005.46 474.792",
    stroke: "#292944",
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.058 448.974C143.028 448.974 155.974 441.847 155.974 433.056C155.974 424.265 143.028 417.138 127.058 417.138C111.087 417.138 98.1406 424.265 98.1406 433.056C98.1406 441.847 111.087 448.974 127.058 448.974Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.564 428.981C154.564 437.343 142.249 444.12 127.059 444.12C111.87 444.12 99.5547 437.343 99.5547 428.981",
    stroke: "#292944",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.814 425.331C147.352 425.331 145.88 425.006 144.594 424.11L146.524 421.342C148.396 422.647 152.073 421.654 154.694 420.185C157.372 418.683 159.272 416.27 159.779 413.727C159.972 412.753 160.365 409.469 157.255 408.108C155.083 407.157 152.318 408.404 150.536 410.055L148.239 407.582C150.638 405.354 154.79 403.344 158.61 405.015C162.157 406.57 163.917 410.248 163.09 414.386C162.394 417.884 159.873 421.152 156.347 423.128C155.498 423.602 152.184 425.331 148.814 425.331Z",
    fill: "#EF750D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.9023 396.398L106.639 428.411C106.639 428.411 109.692 436.939 127.143 436.939C144.594 436.939 147.646 428.411 147.646 428.411L156.383 396.398H97.9023Z",
    fill: "#EF750D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.143 410.621C143.292 410.621 156.383 404.254 156.383 396.399C156.383 388.544 143.292 382.177 127.143 382.177C110.994 382.177 97.9023 388.544 97.9023 396.399C97.9023 404.254 110.994 410.621 127.143 410.621Z",
    fill: "#EF750D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.383 396.399C156.383 404.253 143.292 410.621 127.143 410.621C110.993 410.621 97.9023 404.253 97.9023 396.399",
    stroke: "#292944",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.146 405.976C140.785 405.976 151.842 401.161 151.842 395.221C151.842 389.281 140.785 384.466 127.146 384.466C113.506 384.466 102.449 389.281 102.449 395.221C102.449 401.161 113.506 405.976 127.146 405.976Z",
    fill: "#B75F25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.371 400.599C110.642 403.813 118.616 405.978 127.755 405.978C136.895 405.978 144.869 403.815 149.14 400.599C144.869 397.386 136.895 395.221 127.755 395.221C118.616 395.221 110.642 397.386 106.371 400.599Z",
    fill: "#6B4135"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M828.111 532.664C844.26 532.664 857.352 526.297 857.352 518.442C857.352 510.587 844.26 504.22 828.111 504.22C811.962 504.22 798.871 510.587 798.871 518.442C798.871 526.297 811.962 532.664 828.111 532.664Z",
    fill: "#EF750D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M903.687 542.566L910.633 539.136L876.535 470.14L869.589 473.569L903.687 542.566Z",
    fill: "#EF750D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M870.006 468.976L872.709 467.642C873.88 467.064 875.3 467.543 875.878 468.715L876.571 470.116L869.626 473.545L868.933 472.144C868.353 470.972 868.835 469.555 870.006 468.976Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M876.571 470.115L869.625 473.544",
    stroke: "#A06E42",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M901.498 431.471H869.266L878.789 400.795H911.023L901.498 431.471Z",
    fill: "#FFDFCA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M877.816 425.17H896.382",
    stroke: "#DBA07F",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M879.961 418.472H898.527",
    stroke: "#DBA07F",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M882.695 411.774H901.261",
    stroke: "#DBA07F",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M885.117 405.076H895.172",
    stroke: "#DBA07F",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M923.773 446.158L882.426 449.485L888.42 414.457L923.773 409.783V446.158Z",
    fill: "#DD97BA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M890.891 441.335L917.444 438.642",
    stroke: "#B5788A",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M892.27 433.677L917.444 431.382",
    stroke: "#B5788A",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M894.297 425.934L916.586 424.15",
    stroke: "#B5788A",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M905.605 418.456L916.636 416.999",
    stroke: "#B5788A",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M982.891 537.403L1047.96 499.03L1050.61 476.398L985.542 514.77L982.891 537.403Z",
    fill: "#F7C3BC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M982.889 537.403L890.484 479.54L893.136 456.907L985.541 514.77L982.889 537.403Z",
    fill: "#F7C3BC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M983.458 532.532L891.055 474.669L892.631 461.209L985.036 519.072L983.458 532.532Z",
    fill: "#F7EFE7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1050.6 476.375L961.677 422.36L893.137 456.907L985.542 514.77L1050.6 476.375Z",
    fill: "#FFE3DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1029.95 475.114L1016.1 466.696L968.664 494.149L982.29 502.682L1029.95 475.114Z",
    fill: "#F7C3BC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M987.535 494.93L1020.87 475.153",
    stroke: "#292944",
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M919.82 451.462L949.533 436.283",
    stroke: "#292944",
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M931.625 453.857L953.679 442.591",
    stroke: "#292944",
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M985.035 519.072L983.457 532.532L1044.7 496.411L1046.28 482.949L985.035 519.072Z",
    fill: "#F7EFE7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1032.28 497.525L1022.86 503.116L1027.6 517.958L1037.04 512.094L1032.28 497.525Z",
    fill: "#DD97BA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M927.742 506.585L937.475 513.911L948.461 503.716L937.51 496.918L927.742 506.585Z",
    fill: "#FE624B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M891.812 468.192L984.008 526.006L1045.52 489.489",
    stroke: "#292944",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M657.76 437.701L621.801 439.354L597.43 397.626L633.389 395.973L657.76 437.701Z",
    fill: "#FFEAA4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M629.08 404.121L622.723 424.56L639.211 427.011L629.08 404.121Z",
    stroke: "#D3B562",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M630.1 412.765C629.632 415.785 625.358 417.631 620.553 416.888C615.75 416.144 612.234 413.093 612.702 410.072C613.17 407.051 617.443 405.205 622.248 405.949C627.053 406.691 630.569 409.744 630.1 412.765Z",
    stroke: "#D3B562",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M637.715 433.279L651.401 432.843",
    stroke: "#D3B562",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M607.715 401.919L617.059 401.621",
    stroke: "#D3B562",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M754.263 496.279C754.263 496.279 777.148 496.03 778.428 498.227C779.71 500.422 779.574 508.071 778.823 508.872C777.076 510.732 770.742 513.674 768.514 513.974C766.286 514.273 747.125 512.429 745.575 511.061C744.026 509.692 744.243 504.033 744.449 501.887C744.656 499.737 751.596 496.288 754.263 496.279Z",
    fill: "#75664E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M776.545 499.622C773.816 501.392 770.924 503.218 767.618 503.518C766.531 503.617 765.434 503.544 764.345 503.468C758.567 503.07 752.793 502.618 747.023 502.111",
    stroke: "#5B4D39",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M768.435 512.087C768.312 511.769 767.621 503.518 767.621 503.518",
    stroke: "#5B4D39",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M766.62 539.768L659.073 577.9L597.801 537.84L705.336 500.065L766.62 539.768Z",
    fill: "#FFEAA4"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask19_1623_36489",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -6,
    y: -145,
    width: 1139,
    height: 759
  }, _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M1133 -145H-6V614H1133V-145Z",
    fill: "white"
  }))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask19_1623_36489)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M121.508 278.349C121.508 278.349 133.935 333.411 138.98 346.874C144.507 361.622 151.12 372.996 165.982 387.009C187.599 407.389 215.15 425.385 215.15 425.385L261.365 406.01L203.221 325.355L185.87 251.831",
    fill: "#ED8E6E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.733 233.372L200.233 308.475L124.18 331.133L116.922 270.528",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.18 331.133L116.922 270.528",
    stroke: "#231F20",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.734 233.372L200.234 308.475",
    stroke: "#231F20",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.707 310.496L196.518 287.809",
    stroke: "#231F20",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.852 418.407C213.49 423.999 215.141 429.622 217.712 434.867C220.282 440.111 223.841 445.008 228.689 448.401C231.95 450.683 235.727 452.245 238.809 454.75C241.01 456.538 242.791 458.756 244.523 460.979C245.93 462.789 247.338 464.651 248.084 466.804C249.41 470.631 248.562 475.129 250.746 478.558C251.616 479.922 252.935 481.012 254.464 481.626C256.475 482.433 259.147 482.239 260.422 480.508C261.354 479.241 261.292 477.553 261.192 476.006C261.192 476.006 262.075 478.38 262.648 479.66C263.653 481.907 266.859 483.336 269.294 482.649C271.728 481.961 273.355 479.148 272.518 476.836C273.075 477.976 274.82 478.118 275.906 477.41C276.992 476.703 277.545 475.45 277.944 474.242C278.477 472.629 278.838 470.965 279.021 469.283C279.731 470.235 281.432 469.652 281.968 468.589C282.504 467.527 283.539 465.004 283.561 463.824C283.621 460.706 285.238 457.825 286.003 454.79C286.989 450.882 285.316 448.066 284.776 444.087C284.31 440.643 283.773 437.18 282.564 433.916C276.308 417.024 261.267 406.35 250.95 392.211",
    fill: "#ED8E6E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.306 479.094C260.745 475.327 261.185 471.563 261.624 467.797C261.844 465.914 262.061 463.996 261.704 462.135C261.375 460.419 260.571 458.836 259.779 457.28C257.202 452.227 254.507 447.026 250.137 443.407",
    stroke: "#231F20",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.523 438.373C264.341 441.821 266.159 445.27 267.977 448.717C268.709 450.104 269.444 451.499 269.96 452.981C270.513 454.567 272.082 460.477 272.348 462.135C273.421 468.849 272.762 471.39 272.908 478.189",
    stroke: "#231F20",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.716 470.638C279.787 463.338 280.838 455.673 279.173 448.243C278.936 447.188 278.648 446.15 278.359 445.112C277.876 443.38 277.395 441.648 276.912 439.916C276.379 438.003 275.844 436.083 275.129 434.264",
    stroke: "#231F20",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.526 426.924C212.764 423.213 210.902 419.55 208.941 415.939",
    stroke: "#231F20",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.936 473.734C259.533 473.441 258.096 473.269 256.653 473.223C255.792 473.196 254.842 473.243 254.196 473.787C253.353 474.497 253.408 475.705 253.531 476.738C253.566 477.035 253.604 477.339 253.744 477.606C254.028 478.148 254.673 478.436 255.297 478.617C256.951 479.097 258.776 479.091 260.452 478.6",
    stroke: "#231F20",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.81 477.51C270.991 478.638 268.579 479.839 266.426 478.939C265.876 478.71 265.505 478.19 265.305 477.647C265.139 477.201 265.073 476.725 265.01 476.253C264.74 474.216 265.487 473.286 267.477 472.923C269.12 472.622 270.784 472.442 272.418 472.093",
    stroke: "#231F20",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.534 469.829C277.756 469.848 276.964 469.869 276.23 470.124C275.495 470.379 274.815 470.912 274.584 471.654C274.429 472.149 274.487 472.682 274.546 473.198C274.613 473.787 274.708 474.432 275.152 474.825C275.337 474.989 275.569 475.092 275.805 475.167C276.355 475.338 276.95 475.359 277.51 475.227",
    stroke: "#231F20",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.383 464.26C282.222 464.172 281.021 464.09 279.925 464.478C279.821 464.515 279.714 464.56 279.647 464.648C279.588 464.727 279.571 464.829 279.556 464.928C279.461 465.543 279.369 466.157 279.275 466.771C279.225 467.098 279.18 467.461 279.36 467.742C279.515 467.985 279.802 468.108 280.077 468.193C280.69 468.381 281.342 468.45 281.981 468.396",
    stroke: "#231F20",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.568 325.742C192.195 325.498 174.812 331.508 166.215 337.085",
    stroke: "#231F20",
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask20_1623_36489",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -6,
    y: -145,
    width: 1139,
    height: 759
  }, _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M1133 -145H-6V614H1133V-145Z",
    fill: "white"
  }))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask20_1623_36489)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M898.51 278.188L908.487 310.766L841.57 367.196L883.364 391.929C883.364 391.929 944.378 355.659 960.023 345.569C975.669 335.479 978.361 316.9 974.7 301.377C970.687 284.36 958.283 248.057 958.283 248.057",
    fill: "#ED8E6E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M880.816 177.555C880.816 177.555 920.757 180.417 931.892 191.135C940.857 199.765 948.449 215.384 953.149 226.904C959.14 241.589 973.929 290.119 973.929 290.119L905.718 305.854L887.333 235.274",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M905.717 305.852L887.332 235.273",
    stroke: "#231F20",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M901.586 290.297L968.69 274.171",
    stroke: "#231F20",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M908.074 311.32C917.018 306.107 931.566 306.052 940.589 311.232",
    stroke: "#231F20",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M832.988 375.865C827.587 378.529 822.317 383.48 820.542 388.354C817.995 395.352 818.393 403.283 816.622 410.55C816.378 411.556 816.124 412.677 816.547 413.666C818.244 417.647 825.766 415.987 827.976 414.372C829.402 413.331 830.404 411.676 831.121 409.899C833.188 404.769 833.088 398.505 835.518 393.617C836.591 391.457 838.14 389.643 839.995 388.374",
    fill: "#ED8E6E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M828.466 371.049C822.393 374.95 816.305 379.738 813.781 386.883C811.802 392.486 812.279 398.851 810.856 404.666C810.597 405.72 810.276 406.767 810.251 407.865C810.168 411.52 814.446 412.384 817.024 412.009C820.186 411.547 822.328 408.352 823.254 405.088C824.18 401.825 824.256 398.297 825.216 395.045C826.375 391.117 828.847 387.706 832.09 385.559",
    fill: "#ED8E6E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M830.198 379.754C826.508 381.697 823.583 385.017 821.455 388.789C819.327 392.562 817.947 396.788 816.808 401.059C815.938 404.326 813.731 407.227 810.269 407.412C808.224 407.522 805.009 407.247 804.221 405.175C803.069 402.143 805.577 396.833 806.133 393.856C806.762 390.485 807.467 386.983 808.187 383.728C811.572 368.412 824.567 360.779 837.561 356.243C845.798 353.368 857.613 350.985 866.263 349.806L891.953 385.154C882.41 395.529 873.172 402.052 859.458 399.292C857.78 398.954 851.977 396.952 850.299 397.355C847.95 397.922 844.495 399.27 842.836 401.065C840.965 403.093 840.534 405.377 839.319 407.789C837.963 410.483 836.256 413.25 833.729 414.802C831.554 416.136 827.679 416.646 825.375 415.092C823.82 414.043 823.738 410.696 824.571 409.014C826.737 404.646 826.215 400.478 828.307 395.64C830.4 390.802 832.096 387.258 836.788 384.349",
    fill: "#ED8E6E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M825.363 415.893C823.476 413.92 823.738 410.696 824.572 409.015C826.738 404.648 826.215 400.48 828.308 395.642C830.401 390.804 832.097 387.259 836.788 384.351",
    stroke: "#231F20",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M832.988 375.865C827.587 378.529 822.317 383.48 820.542 388.354C817.995 395.352 818.393 403.283 816.622 410.55C816.378 411.556 816.124 412.677 816.547 413.666",
    stroke: "#231F20",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M828.465 371.049C822.392 374.95 816.303 379.738 813.779 386.883C811.801 392.486 812.277 398.851 810.854 404.666C810.596 405.72 810.274 406.767 810.25 407.865",
    stroke: "#231F20",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M825.349 407.127C826.292 407.276 827.234 407.438 828.173 407.616C828.756 407.727 829.58 407.796 829.983 408.337C830.185 408.607 830.256 408.968 830.238 409.307C830.22 409.645 830.118 409.97 830.01 410.284C829.917 410.556 829.816 410.828 829.664 411.066C828.543 412.824 825.896 412.349 824.242 411.843",
    stroke: "#231F20",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M817.359 407.447C818.363 407.543 819.365 407.637 820.369 407.733C820.527 407.748 820.686 407.763 820.838 407.821C821.206 407.96 821.472 408.337 821.589 408.738C821.704 409.138 821.692 409.562 821.654 409.973C821.617 410.374 821.551 410.79 821.321 411.101C821.066 411.446 820.65 411.604 820.243 411.684C818.999 411.931 817.701 411.604 816.457 411.242",
    stroke: "#231F20",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M811.145 403.075C812.384 403.491 813.625 403.907 814.864 404.323C814.985 404.364 815.114 404.408 815.204 404.508C815.269 404.581 815.307 404.675 815.344 404.768C815.514 405.197 815.688 405.647 815.664 406.105C815.628 406.806 815.116 407.382 814.513 407.626C813.91 407.871 813.23 407.836 812.58 407.725C811.802 407.591 811.035 407.351 810.305 407.013",
    stroke: "#231F20",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M804.614 399.33C805.477 399.673 806.367 399.925 807.269 400.082C807.547 400.13 807.832 400.171 808.087 400.305C808.494 400.519 808.783 400.955 808.897 401.422C809.011 401.89 808.962 402.385 808.824 402.832C808.742 403.098 808.628 403.354 808.453 403.558C808.162 403.896 807.732 404.059 807.304 404.139C806.171 404.353 804.944 404.059 803.969 403.339",
    stroke: "#231F20",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M888.301 389.091C890.477 386.33 892.928 383.786 895.607 381.509",
    stroke: "#231F20",
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask21_1623_36489",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -6,
    y: -145,
    width: 1139,
    height: 759
  }, _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M1133 -145H-6V614H1133V-145Z",
    fill: "white"
  }))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask21_1623_36489)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M672.819 99.0548C661.684 103.997 662.735 102.947 657.79 114.077C652.846 102.947 653.897 103.997 642.762 99.0548C653.897 94.1122 652.846 95.1627 657.79 84.0327C662.735 95.1627 661.684 94.1122 672.819 99.0548Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M731.077 181.203C719.942 186.145 720.993 185.095 716.048 196.225C711.104 185.095 712.154 186.145 701.02 181.203C712.154 176.26 711.104 177.311 716.048 166.181C720.992 177.311 719.942 176.262 731.077 181.203Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M628.975 54.7111C620.336 58.5455 621.151 57.7304 617.315 66.3663C613.479 57.7319 614.294 58.5455 605.656 54.7111C614.294 50.8766 613.48 51.6918 617.315 43.0574C621.151 51.6918 620.337 50.8766 628.975 54.7111Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M881.942 51.3759C873.304 55.2103 874.118 54.3951 870.281 63.0311C866.445 54.3967 867.261 55.2103 858.621 51.3759C867.259 47.5414 866.445 48.3566 870.281 39.7222C874.118 48.3566 873.302 47.5414 881.942 51.3759Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.858 102.422C365.22 106.256 366.034 105.441 362.198 114.077C358.362 105.443 359.177 106.256 350.539 102.422C359.177 98.5874 358.363 99.4025 362.198 90.7666C366.034 99.4025 365.22 98.5889 373.858 102.422Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.153 19.7484C401.514 23.5829 402.328 22.7677 398.492 31.4036C394.656 22.7692 395.472 23.5829 386.832 19.7484C395.47 15.9139 394.656 16.7291 398.492 8.09473C402.33 16.7291 401.514 15.9139 410.153 19.7484Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M625.555 146.029V151.156",
    stroke: "#8C7E56",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M625.555 157.375V162.501",
    stroke: "#8C7E56",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M633.793 154.266H628.664",
    stroke: "#8C7E56",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M622.443 154.266H617.316",
    stroke: "#8C7E56",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.496 66.3662V71.4925",
    stroke: "#8C7E56",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.496 77.7117V82.8364",
    stroke: "#8C7E56",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.734 74.6013H401.605",
    stroke: "#8C7E56",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.382 74.6013H390.254",
    stroke: "#8C7E56",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.188 114.077V119.203",
    stroke: "#8C7E56",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.188 125.422V130.547",
    stroke: "#8C7E56",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.429 122.312H292.301",
    stroke: "#8C7E56",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.078 122.312H280.949",
    stroke: "#8C7E56",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.312 23.167V28.2933",
    stroke: "#8C7E56",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.312 34.5125V39.6372",
    stroke: "#8C7E56",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.55 31.4021H368.422",
    stroke: "#8C7E56",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.203 31.4021H357.074",
    stroke: "#8C7E56",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M724.285 108.404V113.53",
    stroke: "#8C7E56",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M724.285 119.75V124.876",
    stroke: "#8C7E56",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M732.523 116.639H727.395",
    stroke: "#8C7E56",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M721.174 116.639H716.047",
    stroke: "#8C7E56",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M747.07 69.4751V74.6014",
    stroke: "#8C7E56",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M747.07 80.8206V85.9469",
    stroke: "#8C7E56",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M755.312 77.7117H750.184",
    stroke: "#8C7E56",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M743.961 77.7117H738.832",
    stroke: "#8C7E56",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M939.273 151.702V156.828",
    stroke: "#8C7E56",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M939.273 163.048V168.174",
    stroke: "#8C7E56",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M947.511 159.939H942.383",
    stroke: "#8C7E56",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M936.16 159.939H931.031",
    stroke: "#8C7E56",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1623_36489"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1126,
    height: 506,
    rx: 8,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_1623_36489"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1139,
    height: 759,
    fill: "white",
    transform: "translate(-6 -145)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFormBg);
export default __webpack_public_path__ + "static/media/formBg.7cdf8f79b2482ed1192dc1f819f4ff60.svg";
export { ForwardRef as ReactComponent };